module.exports = __webpack_public_path__ + "img/content-pc.e122648f.png";